import * as React from 'react'
import { Slot } from '@radix-ui/react-slot'
import './badge.css'

/**
 * Badge
 *
 * variants: default | secondary | destructive | outline | active | inactive | pending
 * asChild: boolean
 */
export function Badge({
  variant = 'default',
  asChild = false,
  className = '',
  ...props
}) {
  const Comp = asChild ? Slot : 'span'

  return (
    <Comp
      data-slot="badge"
      className={`badge badge-${variant} ${className}`}
      {...props}
    />
  )
}
